<template>
  <div class="one-column-view">
    <div class="article-content">
      <div class="row">
        <div class="col-12 col-md-7 p-3">
          <img src="../assets/contact.png" alt="Contact" class="w-100 m-0" />
        </div>
        <div class="col-12 col-md-5 p-3 contact-form">
          <h5>{{ $t("contact.title") }}</h5>
          <b-form @submit="onSubmit">
            <b-form-group id="input-group-name" label-for="name">
              <b-form-input
                id="name"
                v-model="form.name"
                :placeholder="$t('contact.form.name')"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group id="input-group-email" label-for="email">
              <b-form-input
                id="email"
                v-model="form.email"
                type="email"
                :placeholder="$t('contact.form.email')"
                required
              ></b-form-input>
            </b-form-group>

            <b-form-textarea
              id="message"
              v-model="form.message"
              :placeholder="$t('contact.form.message')"
              rows="7"
              max-rows="10"
              required
            ></b-form-textarea>

            <b-button type="submit" class="btn-gold">{{
              $t("contact.form.send")
            }}</b-button>
            <p>{{ $t("contact.form.tip") }}</p>
          </b-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      //   调用API提交表单数据
      alert(JSON.stringify(this.form));
    },
  },
};
</script>

<style>
.contact-form {
  h5 {
    color: #3b3e51;
    font-size: 1.3rem;
    margin: 1rem 0 2rem;
  }
  input,
  textarea {
    background-color: #f4f9fe;
    border: none;
    margin-bottom: 1rem;
  }
  button.btn-gold {
    padding: 0.5rem 2rem;
    border-radius: 1.5rem;
    margin: 1rem 0;
  }
}
</style>
